import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import flagFontUrl from 'country-flag-emoji-polyfill/dist/TwemojiCountryFlags.woff2?url';

// Chrome/Edge en Windows no dibujan banderas emoji (muestran "DO"): se carga
// una fuente solo con banderas (Twemoji, CC-BY 4.0, ver docs/PAISES.md),
// servida desde nuestro dominio y solo en esos navegadores.
let polyfilled = false;
export const ensureFlagFont = (): void => {
  if (polyfilled || typeof window === 'undefined') return;
  polyfilled = true;
  try {
    polyfillCountryFlagEmojis('Twemoji Country Flags', flagFontUrl);
  } catch {
    /* sin canvas: se ven las letras del código */
  }
};
